import { Component, ControlButton } from 'ca-ui';
import { VRRoomLayoutView } from './layout-view.js';

export class VRInsetMap extends Component {
  static defaultOptions = {
    componentName: 'VRInsetMap',
    hotspotSize: 20,
    fov: 0,
    width: 300,
    height: 300,
    showPerson: false,
    showRoomLayout: false,
    hotspots: [],
    open: false
  };

  constructor (options) {
    super($.extend({}, VRInsetMap.defaultOptions, options));

    this.hotspots = {};

    this.expandCollapseButton = new ControlButton({
      icon: this.open ? 'times' : 'map',
      tooltip: 'Show map',
      tooltipDirection: 'right'
    });
    this.expandCollapseButton.el.addClass('ca-vr_roomcontrol');
    this.add(this.expandCollapseButton);

    this.expandCollapseButton.on(
      'click',
      function () {
        this.expandCollapse();
      }.bind(this)
    );

    this.mapContainer = $('<div class="ca-ui-vrinsetmap_map-container"></div>');
    this.el.append(this.mapContainer);

    // Map
    if (options.media != null) {
      this.mapImg = $('<img class="ca-ui-vrinsetmap_map fa" />');
      this.mapImg.on(
        'load',
        function () {
          const width = this.mapImg.prop('naturalWidth');
          const height = this.mapImg.prop('naturalHeight');
          this.aspectRatio = width / height;

          this.layout();
          if (this.options.open) this.expandCollapse();
        }.bind(this)
      );
      this.mapContainer.append(this.mapImg);
    } else {
      this.aspectRatio = this.options.width / this.options.height;
      this.layout();
      if (this.options.open) this.expandCollapse();
    }

    if (this.options.showRoomLayout) {
      this.roomLayout = new VRRoomLayoutView({ showPerson: true });
      this.mapContainer.append(this.roomLayout.el);
    }

    // Person
    if (this.options.showPerson) {
      this.personHotspot = new InsetMapHotspot({ position: { x: 50, y: 50 } });
      this.personHotspot.el.addClass('ca-ui-vrinsetmap_personhotspot');
      this.mapContainer.append(this.personHotspot.el);

      this.hotspots.person = this.personHotspot;
      this.setActiveHotspot('person');
    }

    this.el.on('click', function (e) {
      console.log('Inset map: ' + e.offsetX + ', ' + e.offsetY);
    });

    this.options.hotspots.forEach(
      function (h) {
        const hotspot = new InsetMapHotspot(h);
        this.hotspots[h.id] = hotspot;
        this.mapContainer.append(hotspot.el);

        if (this.options.onHotspotClick) {
          hotspot.el.on(
            'click',
            function () {
              this.options.onHotspotClick(h.id);
            }.bind(this)
          );
        }
      }.bind(this)
    );

    if (options.media) this.setMedia(options.media);
    this.setFov(this.options.fov);

    $(window).on(
      'resize',
      function () {
        this.layout();
      }.bind(this)
    );
  }

  layout () {
    const maxWidth = Math.min(400, $(window).width() - 60);

    let width = this.options.width;
    let height = this.options.height;

    width = Math.min(maxWidth, width);
    height = width / this.aspectRatio;

    this.el.width(width);
    this.el.height(height);
  }

  expand (expand) {
    if (expand) this.el.removeClass('open');
    else this.el.addClass('open');
    this.expandCollapse();
  }

  expandCollapse () {
    this.el.toggleClass('open');
    const open = this.el.hasClass('open');
    this.el.addClass(open ? 'opening' : 'closing');
    this.expandCollapseButton.setIcon(open ? 'times' : 'map');

    setTimeout(
      function () {
        this.el.removeClass('opening').removeClass('closing');
      }.bind(this),
      200
    );
  }

  addAsset (options) {
    if (this.roomLayout) this.roomLayout.addAsset(options);
  }

  removeAsset (options) {
    if (this.roomLayout) this.roomLayout.removeAsset(options);
  }

  moveAsset (options) {
    if (this.roomLayout) this.roomLayout.moveAsset(options);
  }

  setMedia (media) {
    this.mapImg.attr('src', media);
  }

  setFov (yaw) {
    if (this.activeHotspot) this.activeHotspot.setFov(yaw - 140);
  }

  setActiveAsset (asset) {
    if (this.roomLayout) this.roomLayout.setActiveAsset(asset);
  }

  setActiveHotspot (id) {
    if (this.hotspots[id] == null) return;

    if (this.activeHotspot) this.activeHotspot.setActive(false);

    if (this.hotspots[id]) {
      this.activeHotspot = this.hotspots[id];
      this.activeHotspot.setActive(true);
    }
  }
}

export class InsetMapHotspot extends Component {
  static defaultOptions = {
    componentName: 'InsetMapHotspot',
    size: 20,
    fov: 0,
    position: { x: 0, y: 0 }
  };

  constructor (options) {
    super($.extend({}, InsetMapHotspot.defaultOptions, options));

    this.el.addClass('ca-ui-vrinsetmap_hotspot');
    this.el.width(this.options.size);
    this.el.height(this.options.size);
    if (this.options.position) {
      if (this.options.position.x) {
        this.el.css(
          'left',
          'calc(' +
            this.options.position.x +
            '% - ' +
            this.options.size / 2 +
            'px)'
        );
      }
      if (this.options.position.y) {
        this.el.css(
          'top',
          'calc(' +
            this.options.position.y +
            '% - ' +
            this.options.size / 2 +
            'px)'
        );
      }
    }

    this.el.addClass('ca-ui-vrinsetmap_fovhotspot');

    this.fov = $('<div class="ca-ui-vrinsetmap_fovhotspot_fov"></div>');
    this.fov.css('top', this.options.size / 2 + 'px');
    this.fov.css('left', this.options.size / 2 + 'px');
    this.el.append(this.fov);

    this.setFov(0);
  }

  setActive (show) {
    this.el.toggleClass('active', show);
  }

  setFov (yaw) {
    this.el.css('transform', 'rotate(' + (this.options.fov + yaw) + 'deg)');
  }
}
